<script>
    import ButtonBase from 'common/ButtonBase.svelte';
    import Icon from 'components/Icon.svelte';
    import {
        loginRequestOtpAction,
        loginVerifyOtpAction,
    } from 'domain/auth/auth.actions';
    import AuthStore from 'store/auth';
    import { onMount } from 'svelte';
    import { useNavigate } from 'svelte-navigator';

    const navigate = useNavigate();

    let otp = '';

    let otpInstance;

    let mobile = '';
    let loading = false;
    let errorMessage = ""

    AuthStore.subscribe((value) => {
        const { mobile: phone } = value ? value.user : {}
        mobile = phone;
    });

    let getOtp = () => {
        otp = Array.from(otpInstance?.children || [])
            .map((el) => el.value)
            .join('');
    };

    let validateInput = (input) => {
        input.value = input.value.replace(/[^0-9]/g, '');
        getOtp();
    };

    let switchOtpBox = (val) => {
        let input = document.querySelectorAll('input');
        if (input[val - 1].value != '') {
            input[val].focus();
        } else if (input[val - 1].value == '') {
            input[val - 2].focus();
        }
    };

    let timeout = null;

    let startTimer = (timer) => {
        let time = 60;
        timeout = setInterval(() => {
            time--;
            let minutes = Math.floor(time / 60);
            let seconds = time % 60;
            timer.innerHTML = `Resend in ${minutes}:${seconds}`;
            if (time <= 0) {
                clearInterval(timeout);
                timer.innerHTML = '';
                timer.appendChild(createButton());
            }
        }, 1000);
    };

    let createButton = () => {
        let button = document.createElement('button');
        button.classList.add('resend_button');
        button.innerHTML = 'Resend';
        button.addEventListener('click', resendOtp);
        return button;
    };

    onMount(() => {
        let timer = document.querySelector('.resend-code span');

        startTimer(timer);
    });

    let resendOtp = async () => {
        let timer = document.querySelector('.resend-code span');
        timer.innerHTML = 'resend in 0:59';

        startTimer(timer);

        const response = await loginRequestOtpAction(mobile);
    };

    let verifyOtp = async () => {
        loading = true
        try {
            const response = await loginVerifyOtpAction(mobile, otp);
            navigate('/choose-number');
        } catch (error) {
            const { message, token } = error
            errorMessage = token || message
        } finally {
            loading = false
        }
    };
</script>

<div id="otp-login" class="row content">
    <section class="display-flex">
        <div class="logo marginTop2r"><Icon icon="logo" size="96" /></div>

        <div class="heading">Enter OTP sent to {$AuthStore.user.mobile}</div>

        <div class="otp-code" bind:this={otpInstance}>
            <input
                type="text"
                value=""
                on:input={(e) => validateInput(e.target)}
                on:keyup={() => switchOtpBox(1)}
                maxlength="1"
            />
            <input
                type="text"
                value=""
                on:input={(e) => validateInput(e.target)}
                on:keyup={() => switchOtpBox(2)}
                maxlength="1"
            />
            <input
                type="text"
                value=""
                on:input={(e) => validateInput(e.target)}
                on:keyup={() => switchOtpBox(3)}
                maxlength="1"
            />
            <input
                type="text"
                value=""
                on:input={(e) => validateInput(e.target)}
                on:keyup={() => switchOtpBox(4)}
                maxlength="1"
            />
            <input
                type="text"
                value=""
                on:input={(e) => validateInput(e.target)}
                on:keyup={() => switchOtpBox(5)}
                maxlength="1"
            />
            <input
                type="text"
                value=""
                on:input={(e) => validateInput(e.target)}
                maxlength="1"
            />
        </div>

        <ButtonBase disabled={otp.length !== 6} on:click={verifyOtp} style="width: 100%;" {loading} hasBg={true}>
            <button class={`button ${loading ? 'loading' : ''}`} > Verify </button>
        </ButtonBase>

        <div class="error-msg">{ errorMessage }</div>

        <div class="resend-code">
            Didn’t receive a code? <span>Resend in 0:59</span>
        </div>
    </section>
</div>

<style lang="scss">
    #otp-login {
        section {
            margin: 0 1.25rem;
            .heading {
                margin-top: 1.5rem;
                margin-bottom: 1rem;
            }
            .otp-code {
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 0.5em;
                margin-bottom: 3.5rem;
            }
            input {
                width: 40px;
                height: 40px;
                text-align: center;
                outline: none;
                border: 1px solid #eeeeee;
                border-radius: 4px;
                color: #5b6871;
            }
            .resend-code {
                font-family: 'Urbanist';
                font-style: normal;
                font-weight: 400;
                font-size: 16px;
                line-height: 140%;
                color: #5b6871;
                padding-top: 1rem;
            }
            .resend-code span {
                font-weight: 700;
                font-size: 16px;
                line-height: 140%;
                color: #0e99d2;
            }
            .button {
                width: 100%;
            }
        }
    }

    button:disabled, .button.loading {
        background-color: #7cbdd7;
    }
    .error-msg {
        color: #a10e0e;
        font-size: 10px;
        margin-top: 5px;
    }
</style>
